import PersonalInfoFormContainer from './personal_info_form_container';

const PersonalInfoForm = PersonalInfoFormContainer;
export default PersonalInfoForm;
